(function (app) {
    app.provider("investmentAccountApi", [function () {
        this.$get = ["crmApiGateway", "$q", function (crmApiGateway, $q) {
            var service = {};

            service.get = function(investmentAccountId) {
                return crmApiGateway.get("/InvestmentAccounts/" + investmentAccountId);
            };

            service.getInvestmentAccounts = function() {
                return crmApiGateway.getArray("/InvestmentAccounts");
            };

            service.getCaseInvestmentAccounts = function(caseId) {
                return crmApiGateway.getArray("/Cases/" + caseId + "/InvestmentAccounts");
            };

            service.getNotes = function(investmentAccountId) {
                return crmApiGateway.getArray("/InvestmentAccounts/" + investmentAccountId + "/Notes");
            };

            service.getNote = function(investmentAccountId, noteId) {
                return crmApiGateway.get("/InvestmentAccounts/" + investmentAccountId + "/Notes/" + noteId);
            };

            service.update = function(investmentAccountId, investmentAccount) {
                return crmApiGateway.put("/InvestmentAccounts/" + investmentAccountId, investmentAccount);
            };

            service.updateCustodian = function(investmentAccountId, investmentAccount) {
                return crmApiGateway.put("/InvestmentAccounts/" + investmentAccountId + "/Custodian",
                    investmentAccount);
            };

            service.updateAccountStatus = function(investmentAccountId, investmentAccount) {
                return crmApiGateway.put("/InvestmentAccounts/" + investmentAccountId + "/AccountStatus",
                    investmentAccount);
            };

            service.updateInvestmentAccountType = function(investmentAccountId, investmentAccount) {
                return crmApiGateway.put("/InvestmentAccounts/" + investmentAccountId + "/InvestmentAccountType",
                    investmentAccount);
            };

            service.updateNote = function(investmentAccountId, noteId, note) {
                return crmApiGateway.put("/InvestmentAccounts/" + investmentAccountId + "/Notes/" + noteId, note);
            };

            service.create = function(investmentAccount) {
                return crmApiGateway.post("/InvestmentAccounts", investmentAccount);
            };

            service.addNote = function(investmentAccountId, note) {
                return crmApiGateway.post("/InvestmentAccounts/" + investmentAccountId + "/Notes", note);
            };

            service.delete = function(investmentAccountId) {
                return crmApiGateway.delete("/InvestmentAccounts/" + investmentAccountId);
            };

            service.removeNote = function(investmentAccountId, noteId) {
                return crmApiGateway.delete("/InvestmentAccounts/" + investmentAccountId + "/Notes/" + noteId);
            };

            return service;
        }];
    }]);
})(window.app); //jshint ignore:line